module.exports = __webpack_public_path__ + "img/building14.481207e3.jpg";